export default function createLogger(isEnabled, getStats) {
    return {
        info: isEnabled
            ? (...args) => console.info(...args, getStats())
            : () => { },
        debug: isEnabled
            ? (...args) => console.debug(...args, getStats())
            : () => { },
        error: isEnabled
            ? (...args) => console.error(...args, getStats())
            : () => { },
    };
}
//# sourceMappingURL=log.js.map